import type { TranslationFunction } from 'shared/lib/i18n'

/** An amount in a table or a figure: `42 000`, a minus line `−12 000` — the currency («сум») is in the label, once. */
export function sum(amount: number): string {
	return amount < 0 ? `−${Math.abs(amount).toLocaleString('ru-RU')}` : amount.toLocaleString('ru-RU')
}

/** An amount in a sentence: «42 000 сум». */
export function som(t: TranslationFunction<undefined>, amount: number): string {
	return t('money.som', { amount: sum(amount) })
}

/**
 * Table options for a list that comes whole from the server: no paging, sorting or
 * filtering on the server, one page with every row.
 */
export const WHOLE = {
	manualPagination: false,
	manualSorting: false,
	manualFiltering: false,
	enableRowSelection: false,
	initialState: { pagination: { pageIndex: 0, pageSize: 10000 } },
} as const

/** A money column: its header and its cells to the right. */
export const MONEY_COLUMN = { headClassName: 'text-right', cellClassName: 'text-right tabular-nums' }